app.notifications = app.notifications || {};

/**
 * Global notification system for consistent messaging
 */
// Cache localhost check once
const IS_LOCALHOST = 

app.notifications = {
    /**
     * Show notification message (only on localhost)
     * @param {string} type - Message type: 'error', 'warn', 'info', 'user'
     * @param {string} message - Primary message to display
     * @param {...any} args - Additional arguments (objects, context data, etc.)
     */
    show: (type, message, ...args) => {
        // Early return if not on localhost
        if (!app.data.isLocalhost) return;
        
        // Format message with context if provided
        const fullMessage = args.length > 0 ? `${message}` : message;
        
        switch (type) {
            case 'error':
                console.error(fullMessage, ...args);
                break;
            case 'warn':
                console.warn(fullMessage, ...args);
                break;
            case 'info':
                console.log(fullMessage, ...args);
                break;
            case 'user':
                // TODO: Replace with your actual user notification system
                // This should show notifications to end users (toasts, modals, etc.)
                console.log(`[USER NOTIFICATION]: ${fullMessage}`, ...args);
                break;
            default:
                console.log(fullMessage, ...args);
        }
    }
};